import { Book, BookStatus } from '../interfaces';

const API_BASE_URL_DEV = 'http://localhost:8000/api'; // 假設後端運行在 8000 埠
const API_BASE_URL = 'https://bookapi.sodomcode.com/api';


export const getAllBooks = async (query?: string): Promise<Book[]> => {
  const url = query ? `${API_BASE_URL}/books?q=${encodeURIComponent(query)}` : `${API_BASE_URL}/books`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const getBookById = async (id: number): Promise<Book> => {
  const response = await fetch(`${API_BASE_URL}/books/${id}`);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const createBook = async (bookData: Omit<Book, 'id'>): Promise<Book> => {
  const response = await fetch(`${API_BASE_URL}/books`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bookData),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const updateBook = async (id: number, bookData: Omit<Book, 'id'>): Promise<Book> => {
  const response = await fetch(`${API_BASE_URL}/books/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bookData),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const deleteBook = async (id: number): Promise<Response> => {
  const response = await fetch(`${API_BASE_URL}/books/${id}`, {
    method: 'DELETE',
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response;
};

export const getStatuses = async (): Promise<BookStatus[]> => {
  const response = await fetch(`${API_BASE_URL}/statuses`);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};